import {remCalc} from '../_utils'
import {Typography} from '../types/typography.types'
import fonts from './fonts'

const primaryDefault = {
    fontFamily: `${fonts.fonts.primary}`,
    fontStyle: 'normal',
    letterSpacing: 0,
}

const secondaryDefault = {
    fontFamily: `${fonts.fonts.secondary}`,
    fontStyle: 'normal',
    letterSpacing: 0,
}

const typography: Typography = {
    textStyles: {
        'display-large': {
            ...primaryDefault,
            fontSize: {base: remCalc(40), md: remCalc(50), lg: remCalc(64)},
            lineHeight: {base: remCalc(50), md: remCalc(60), lg: remCalc(80)},
        },
        'display-small': {
            ...primaryDefault,
            fontSize: {base: remCalc(32), lg: remCalc(48)},
            lineHeight: {base: remCalc(40), md: remCalc(50), lg: remCalc(60)},
        },
        'head-xlarge': {
            ...secondaryDefault,
            fontSize: {base: remCalc(32), lg: remCalc(40)},
            lineHeight: {base: remCalc(40), lg: remCalc(50)},
        },
        'head-large': {
            ...secondaryDefault,
            fontSize: {base: remCalc(28), lg: remCalc(32)},
            lineHeight: {base: remCalc(34), md: remCalc(35), lg: remCalc(40)},
        },
        'head-medium': {
            ...secondaryDefault,
            fontSize: {base: remCalc(24), lg: remCalc(28)},
            lineHeight: {base: remCalc(26), md: remCalc(30), lg: remCalc(35)},
        },
        'head-small': {
            ...secondaryDefault,
            fontSize: {base: remCalc(20), lg: remCalc(24)},
            lineHeight: {base: remCalc(25), lg: remCalc(30)},
        },
        'head-xsmall': {
            ...secondaryDefault,
            fontSize: {base: remCalc(18), md: remCalc(20)},
            lineHeight: {base: remCalc(24), md: remCalc(25)},
        },
        'head-xxsmall': {
            ...secondaryDefault,
            fontSize: {base: remCalc(16)},
            lineHeight: {base: remCalc(24)},
        },
        'body-xxlarge': {
            ...secondaryDefault,
            fontSize: {base: remCalc(22)},
            lineHeight: {base: remCalc(28)},
        },
        'body-xlarge': {
            ...secondaryDefault,
            fontSize: {base: remCalc(20)},
            lineHeight: {base: remCalc(26)},
        },
        'body-large': {
            ...secondaryDefault,
            fontSize: {base: remCalc(18)},
            lineHeight: {base: remCalc(24)},
        },
        'body-medium': {
            ...secondaryDefault,
            fontSize: {base: remCalc(16)},
            lineHeight: {base: remCalc(24)},
        },
        'body-small': {
            ...secondaryDefault,
            fontSize: {base: remCalc(14)},
            lineHeight: {base: remCalc(21)},
        },
        'body-xsmall': {
            ...secondaryDefault,
            fontSize: {base: remCalc(12)},
            lineHeight: {base: remCalc(18)},
        },
        'body-xxsmall': {
            ...secondaryDefault,
            fontSize: {base: remCalc(8)},
            lineHeight: {base: remCalc(10)},
        },
    },
}

export default typography
